/**
 * 向 logical_flag 逗号串追加 flag（去重、忽略空段）。
 */
export function appendLogicalFlag(
  existing: string | undefined | null,
  flag: string,
): string {
  const next = String(flag || '').trim();
  if (!next) {
    return String(existing || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
      .join(',');
  }
  const parts = String(existing || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);
  if (!parts.includes(next)) {
    parts.push(next);
  }
  return parts.join(',');
}

export const SPECIAL_DEALS_LOGICAL_FLAG = 'show_special_deals';
